// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1369":"rrule","6346":"VoltoFormBlockEdit","6454":"Widgets","7051":"plone-volto-components-manage-Controlpanels-Aliases","9312":"taxonomy-edit-tree"}[chunkId] + "." + {"1369":"60972e15","6346":"1b7d6ecf","6454":"ac119948","7051":"ac119948","9312":"5598ea9f"}[chunkId] + ".chunk.css";
};